/* global axios */
import ApiClient from './ApiClient';

class CompanyAddressesAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  getAddresses(companyId) {
    return axios.get(`${this.url}/${companyId}/addresses`);
  }

  create(companyId, data) {
    return axios.post(`${this.url}/${companyId}/addresses`, {
      address: data,
    });
  }

  update(companyId, addressId, data) {
    return axios.patch(`${this.url}/${companyId}/addresses/${addressId}`, {
      address: data,
    });
  }

  delete(companyId, addressId) {
    return axios.delete(`${this.url}/${companyId}/addresses/${addressId}`);
  }
}

export default new CompanyAddressesAPI();
